import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { addAuthor } from 'src/store/actions/speech.action';
import Swal from 'sweetalert2';

@Component({
  selector: 'add-author-form',
  templateUrl: './add-author-form.component.html',
  styleUrls: ['./add-author-form.component.css'],
})
export class AddAuthorFormComponent implements OnInit {
  newAuthor: string = '';
  authors$: Array<string> = [];

  constructor(private store: Store<{ speech: any }>) {
    this.store.select('speech').subscribe((q) => {
      this.authors$ = q.authors;
    });
  }

  ngOnInit(): void {}

  onAuthorAdd(event: Event): void {
    event.preventDefault();
    const lowerCased = this.authors$.map((q: string) => q.toLowerCase());

    if (this.newAuthor) {
      if (lowerCased.includes(this.newAuthor.toLowerCase().trim())) {
        Swal.fire('Author already exists', '', 'error');
      } else {
        this.store.dispatch(addAuthor({ author: this.newAuthor }));
        this.newAuthor = '';
      }
    } else {
      Swal.fire('Please enter author', '', 'error');
    }
  }
}
